export const getTagsParam = (storeZoneSelected) => {
  return isZonePickingStore(storeZoneSelected) ? '&tags=' + storeZoneSelected.join('&tags=') : '&tags=others'
}
export const isZonePickingStore = (storeZoneSelected) => {
  return (storeZoneSelected && storeZoneSelected.length ) ? true : false
}
